import { useRef } from 'react';

const useFrozen = <T>(value: T) => {
    const ref = useRef<T>();

    // Only update the ref the first time
    if (ref.current === undefined) {
        ref.current = value;
    }

    return ref.current;
};

export default useFrozen;
